import { request } from 'api';

export class AuthApi {
  static async getUserInfo() {
    return request("userinfo");
  }
}
